import { Injectable, EventEmitter } from '@angular/core';

declare var $:any; // jquery hook

@Injectable()

/**
 * Stylesheet monitor for when CSS file is disabled
 * watches for computed style signature to detect change 
 */

export class CSSMonitorService {
    private INTERVAL: number = 1000;
    private isMonitoring: boolean = false;
    private isCSSEnabled: boolean = true;

    public CSS_DISABLED: string = 'cssdisabled';
    public CSS_ENABLED: string = 'cssenadled';

    constructor() {}

    public styleChangeEvent: EventEmitter<string> = new EventEmitter<string>()

    public getIsRunning() {
		return this.isMonitoring;
	}

    public getCSSEnabled() {
		return this.isCSSEnabled;
	}

    public start() {
		if (this.isMonitoring == false) {
            this.monitorStyleChange();
            this.isMonitoring = true;
		}
	}

    public monitorStyleChange() {
        setInterval(() => { this.checkForStyleChange(); }, this.INTERVAL);
    }

    public checkForStyleChange() {
        // computed style features
        let bodyBoxSizing = $("body").css("box-sizing");            // enabled: border-box | disabled: content-box
        let languageNavCursor = $("#languageMenu").css("cursor");   // enabled: pointer | disabled: auto
        let documentHasCssFeatures = (bodyBoxSizing == "border-box") && (languageNavCursor == "pointer");

        if (documentHasCssFeatures == true && this.isCSSEnabled == false) { 
            this.styleChangeEvent.emit(this.CSS_ENABLED);
        } else if(documentHasCssFeatures == false && this.isCSSEnabled == true) {
            this.styleChangeEvent.emit(this.CSS_DISABLED);
        } 
        
        this.isCSSEnabled = documentHasCssFeatures;
    }
}